import React, { FunctionComponent } from 'react';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { v4 as uuid } from 'uuid';
import { Checkbox, withStyles } from '@material-ui/core';
import { _t } from 'app/utils/i18n';
import {
  Block,
  UnBlock,
  MakeReport,
  RestartIcon,
  UnnecessaryIcon,
  AddToPermIcon,
  MergeIcon,
  AttachToParent,
  TrashIcon,
  BookmarkIcon,
  ResetIcon,
  LinkageIcon,
  CheckBoxIschecked,
  ImportantIcon,
  UnimportantIcon,
  HideIcon,
  Active,
  Deactive,
} from 'app/assets/images/icons';
import styles from './PrimaryMainTable.module.scss';
import { ReactComponent as SortIcon } from 'app/assets/images/sortIcon.svg';

const defaultStyle = {
  display: 'inline-block',
  marginRight: 5,
  marginLeft: 5,
  width: 8,
  verticalAlign: 'middle',
};

const SortIndicator = ({ direction }: { direction: null | number }) => {
  return (
    <div style={defaultStyle} key={uuid()}>
      {direction &&
        (direction !== 1 ? (
          <ExpandLess className={styles.PrimaryTable__Indicator} />
        ) : (
          <ExpandMore className={styles.PrimaryTable__IndIcator} />
        ))}
    </div>
  );
};
interface TDefaultHeader {
  children: any;
  sortable: any;
}
export const renderDefaultHeader: FunctionComponent<TDefaultHeader> = ({
  children,
  sortable,
}) => {
  return (
    <div style={{ paddingBottom: '10px' }}>
      {sortable && <SortIcon />} {'  '}
      {children}
    </div>
  );
};

export const renderSortTool = (direction: number | null): JSX.Element => {
  return <SortIndicator direction={direction} key={uuid()} />;
};

export const checkboxColumn = {
  renderCheckbox: (
    checkboxProps: Record<string, any>,
    cellProps: Record<string, any>,
  ) => {
    const { onChange, checked } = checkboxProps as any;
    if (cellProps.data?.hidden === true) {
      return ' ';
    } else {
      return (
        <div
          className="tableCheckBox"
          style={{
            cursor: cellProps.data?.is_merged?'':'pointer',
            background: cellProps.data?.is_merged?'gray':'#FFF',
            height: '15px',
            width: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: cellProps.data?.is_merged?'2px solid gray':'1px solid var(--mainColor)',
            fontSize: 22,
            color: checked === false ? 'inherit' : 'var(--mainColor)',
          }}
          onClick={(e) => {
            e.stopPropagation();
            if(!cellProps.data?.is_merged){
              onChange(!checked);
            }
          }}
        >
          {checked === false ? (
            ' '
          ) : checked === true ? (
            <CheckBoxIschecked />
          ) : (
            '-'
          )}
        </div>
      );
    }
  },
};
export const CustomCheckbox = withStyles({
  root: {
    color: 'var(--mainColor)',
    marginInlineEnd: '3px',
    height: '15px',
    padding: '9px',
    width: '15px',
    '&$checked': {
      color: 'var(--mainColor)',
    },
  },
  checked: {},
})((props: any) => <Checkbox color="default" {...props} />);

export const emptyText = (
  <p
    style={{
      color: 'var(--mainColor)',
      fontSize: '14px',
      textTransform: 'uppercase',
    }}
  >
    {_t('basic:no_data')}
  </p>
);

export const bulkActionMap = [
  {
    value: 'restore',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <ResetIcon />
        <span>{_t('basic:restore')}</span>
      </div>
    ),
  },
  {
    value: 'merge',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <MergeIcon />
        <span>{_t('basic:merge')}</span>
      </div>
    ),
  },
  {
    value: 'delete',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <TrashIcon />
        <span>{_t('basic:delete')}</span>
      </div>
    ),
  },
  {
    value: 'important',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<ImportantIcon />}
        <span>{_t('basic:important')}</span>
      </div>
    ),
  },
  {
    value: 'unimportant',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<UnimportantIcon />}
        <span>{_t('basic:unimportant')}</span>
      </div>
    ),
  },
  {
    value: 'trash',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <TrashIcon />
        <span>{_t('basic:trash')}</span>
      </div>
    ),
  },
  {
    value: 'trash-or-unnecessary',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <HideIcon />
        <span>{_t('basic:hide')}</span>
      </div>
    ),
  },
  {
    value: 'compare',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <span className={styles.PrimaryTable__BulkActionOpts__Icon}>
          {_t('basic:compareText')}
        </span>
        {/* V.S. */}
        <span>{_t('basic:compare')}</span>
      </div>
    ),
  },
  {
    value: 'bookmark',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        <BookmarkIcon />
        <span>{_t('basic:bookmark')}</span>
      </div>
    ),
  },
  {
    value: 'regrab',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<RestartIcon />}
        <span>{_t('basic:regrab')}</span>
      </div>
    ),
  },
  {
    value: 'sync',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<RestartIcon />}
        <span>{_t('basic:sync')}</span>
      </div>
    ),
  },
  {
    value: 'check',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<RestartIcon />}
        <span>{_t('basic:check')}</span>
      </div>
    ),
  },
  {
    value: 'partial-sync',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<RestartIcon />}
        <span>{_t('basic:partial-sync')}</span>
      </div>
    ),
  },
  {
    value: 'permission',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<AddToPermIcon />}
        <span>{_t('basic:add_permission')}</span>
      </div>
    ),
  },

  {
    value: 'block',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<Block />}
        <span>{_t('users:block_action')}</span>
      </div>
    ),
  },
  {
    value: 'active',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<Active />}
        <span>{_t('reports:active')}</span>
      </div>
    ),
  },
  {
    value: 'deactive',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<Deactive />}
        <span>{_t('reports:deactive')}</span>
      </div>
    ),
  },
  {
    value: 'unblock',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<UnBlock />}
        <span>{_t('basic:un_block')}</span>
      </div>
    ),
  },
  {
    value: 'report',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<MakeReport />}
        <span>{_t('basic:make_report')}</span>
      </div>
    ),
  },
  {
    value: 'fastReport',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<MakeReport />}
        <span>{_t('basic:make_report')}</span>
      </div>
    ),
  },
  {
    value: 'attach',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<AttachToParent />}
        <span>{_t('basic:attach_to_parent')}</span>
      </div>
    ),
  },
  {
    value: 'unnecessary',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<UnnecessaryIcon />}
        <span>{_t('basic:unnecessary')}</span>
      </div>
    ),
  },
  {
    value: 'linkage',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<LinkageIcon />}
        <span>{_t('news:linkage')}</span>
      </div>
    ),
  },
  {
    value: 'mergeAuthor',
    label: (
      <div className={styles.PrimaryTable__BulkActionOpts}>
        {<MergeIcon />}
        <span>{_t('news:marge')}</span>
      </div>
    ),
  },
];
export const getTableMinHeight = (rowNumber: number): number => {
  let minHeight = 812;
  switch (rowNumber) {
    case 20:
      minHeight = 855;
      break;
    case 40:
      minHeight = 825;
      break;
    case 80:
      minHeight = 808;
      break;
    case 100:
      minHeight = 805;
      break;
  }
  return minHeight;
};
